// frontend/packages/business-console/src/pages/AiUsage.jsx
//
// Dedicated tenant-facing AI usage page. Shows month-to-date AI/API
// spend vs the monthly cap, when it resets, AI tokens used, and a
// per-api spend breakdown — all from GET /api/v2/ai-usage.
//
// `/business/:slug/ai-usage`

import React from 'react';
import { Box, Typography } from '@mui/material';

import AiUsageMeter from '../components/AiUsageMeter';
import AiOverageOptIn from '../components/AiOverageOptIn';
import { useTokens, PageHeader } from '../components/primitives';

export default function AiUsage() {
  const t = useTokens();
  return (
    <Box sx={{ p: 3, maxWidth: 880, mx: 'auto' }}>
      <PageHeader title="AI usage" sx={{ mb: 0.75 }} />
      <Typography sx={{ fontSize: 13.5, color: t.muted, mb: 3 }}>
        How much AI your business has used this month. Features like the AI Form
        Builder draw from your monthly allowance. Usage resets at the start of
        each month.
      </Typography>

      <AiUsageMeter variant="full" />

      <AiOverageOptIn />
    </Box>
  );
}
